<template>
  <v-dialog
    v-model="dialog"
    persistent
    scrollable
    max-width="1200px"
  >
    <v-card :loading="loading">
      <v-card-title>
        <span v-if="item.id">Cập nhật dữ liệu</span>
        <span v-else>Thêm mới</span>
        <v-spacer/>
        <v-menu
          bottom
          left
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              @click="close()"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
        </v-menu>
      </v-card-title>
      <v-card-text>
        <v-container>
          <div v-if="errors_exist" class="row">
            <div class="col">
              <v-alert
                dense
                outlined
                type="error"
              >
                {{ $vuetify.lang.t('$vuetify.msg.hasError') }}
                <ul>
                  <div v-for="(error, index) in errors">
                    <li :key="index">{{ error[0] }}</li>
                  </div>
                </ul>
              </v-alert>
            </div>
          </div>
          <v-row>
            <v-col
              cols="12"
              class="text-center"
            >
              <input 
                type="file" 
                @change="onFilePicked" 
                class="d-none" 
                ref="fileInput" 
                accept="image/*"
              />
              <v-img
                v-if="anh_dai_dien_url"
                :src="anh_dai_dien_url"
                class="mx-auto elevation-1"
                @click="onPickFile"
                width="150"
              />
              <v-img
                v-else
                src="@/assets/NoImage.jpg"
                class="mx-auto elevation-1"
                @click="onPickFile"
                width="150"
              />
              <div class="red--text mt-2">
                Lưu ý: Chỉ chấp nhận tập tin dạng: *.jpg, *.jpeg, *.png và kích thước <= 2MB
              </div>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="item.ten_sp"
                label="Tên sản phẩm"
                autofocus
                class="require"
                hide-details
              />
            </v-col>
            <v-col cols="12">
              <v-select
                v-model="typeSelected"
                :items="types"
                item-text="ten_loai"
                item-value="id"
                label="Loại"
                class="require"
                return-object
                hide-details
              />
            </v-col>
            <v-col cols="12">
              <label>Mô tả</label>
              <quill-editor 
                v-model="item.mo_ta"
                :options="editorOption"
                style="min-height:150px;"
              >
              </quill-editor>
            </v-col>
            <v-col cols="12">
              <label>Hình ảnh</label>
              <vue-dropzone 
                ref="myVueDropzone" 
                id="dropzone" 
                :options="dropzoneOptions"
                v-on:vdropzone-success="uploadSuccess"
                v-on:vdropzone-error="uploadError"
                v-on:vdropzone-removed-file="fileRemoved"
                @vdropzone-mounted="loadPictures"
              />
              <div class="red--text text-center">
                Lưu ý: Chỉ chấp nhận tập tin dạng: *.jpg, *.jpeg, *.png và kích thước <= 2MB
              </div>
            </v-col>
            <v-col cols="12">
              <v-text-field
                type="number"
                v-model="item.gia_ban"
                label="Giá bán"
                hide-details
              />
            </v-col>
            <v-col
              v-if="!businessId"
              cols="12"
            >
              <v-select
                v-on:change="getCoopesByBusiness"
                v-model="businessSelected"
                :items="businesses"
                item-text="ten_co_so"
                item-value="id"
                label="Cơ sở sản xuất"
                return-object
                hide-details
              />
            </v-col>
            <v-col cols="12">
              <v-select
                v-model="coopeSelected"
                :items="coopes"
                item-text="ten_npp"
                item-value="id"
                label="Nhà phân phối"
                multiple
                return-object
                hide-details
              />
            </v-col>
            <v-col cols="12">
              <label>Công dụng</label>
              <quill-editor 
                v-model="item.cong_dung"
                :options="editorOption"
                style="min-height:100px;"
              >
              </quill-editor>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-tabs
                v-model="tab"
                centered
                class="my-4 rounded-t-lg"
                background-color="primary"
                dark
              >
                <v-tabs-slider/>

                <v-tab href="#trace-1">
                  Sản xuất, nuôi trồng
                </v-tab>

                <v-tab href="#trace-2">
                  Thu hoạch
                </v-tab>

                <v-tab href="#trace-3">
                  Sơ chế, đóng gói
                </v-tab>
              </v-tabs>
              
              <v-tabs-items v-model="tab">
                <v-tab-item
                  :value="'trace-1'"
                >
                  <v-row>
                    <v-col
                      cols="12"
                      sm="6"
                      md="6"
                    >
                      <v-text-field
                        v-model="item.ten_giong"
                        label="Tên giống"
                        hide-details
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="6"
                    >
                      <v-text-field
                        v-model="item.nguon_goc"
                        label="Nguồn gốc giống"
                        hide-details
                      />
                    </v-col>
                    <v-col cols="12">
                      <label>Quy trình sản xuất</label>
                      <quill-editor 
                        v-model="item.quy_trinh_sx"
                        :options="editorOption"
                        style="min-height:150px;"
                      >
                      </quill-editor>
                    </v-col>
                  </v-row>
                </v-tab-item>
                <v-tab-item :value="'trace-2'">
                  <v-row>
                    <v-col
                      cols="12"
                      sm="6"
                      md="6"
                    >
                      <v-text-field
                        v-model="item.ngay_thu_hoach_dg"
                        label="Ngày thu hoạch, đóng gói"
                        v-mask="'##/##/####'"
                        hide-details
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="6"
                    >
                      <v-text-field
                        v-model="item.san_luong"
                        label="Sản lượng"
                        hide-details
                      />
                    </v-col>
                    <v-col cols="12">
                      <v-select
                        v-model="warehouseSelected"
                        :items="warehouses"
                        item-text="ten_kho"
                        item-value="id"
                        label="Kho, xưởng"
                        multiple
                        return-object
                      />
                    </v-col>
                  </v-row>
                </v-tab-item>
                <v-tab-item :value="'trace-3'">
                  <v-row>
                    <v-col
                      cols="12"
                      sm="6"
                      md="6"
                    >
                      <v-text-field
                        v-model="item.han_su_dung"
                        label="Hạn sử dụng"
                        hide-details
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="6"
                    >
                      <v-text-field
                        v-model="item.quy_cach"
                        label="Quy cách"
                        hide-details
                      />
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="item.cach_bao_quan"
                        label="Cách bảo quản"
                        hide-details
                      />
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="item.don_vi_kt"
                        label="Đơn vị kiểm định"
                      />
                    </v-col>
                  </v-row>
                </v-tab-item>
              </v-tabs-items>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <small><span class="pink--text">(*)</span> bắt buộc nhập</small>
        <v-spacer/>
        <v-btn
          color="pink darken-1"
          text
          @click="close"
        >
          Hủy bỏ
        </v-btn>
        <v-btn
          color="primary darken-1"
          text
          @click="save(item)"
        >
          Lưu lại
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  import vue2Dropzone from 'vue2-dropzone';
  import 'vue2-dropzone/dist/vue2Dropzone.min.css';
  import { mapState, mapActions } from 'vuex';
  export default {
    components: { 
      vueDropzone: vue2Dropzone,
    },
    props: {
      showDialog: {
        type: Boolean,
        default: false
      },
      item: {
        type: Object
      },
      businessId: {
        type: Number,
      },
    },
    data () {
      return {
        loading: false,
        tab: null,
        dialog: false,
        anh_dai_dien_url: null,
        errors_exist: false,
        errors: [],
        types: [],
        typeSelected: null,
        businesses: [],
        businessSelected: null,
        areas: [],
        areaSelected: null,
        coopes: [],
        coopeSelected: [],
        images: [],
        dropzoneOptions: {
          url: null,
          addRemoveLinks: true,
          dictRemoveFile: "×",
          dictDefaultMessage: "<i class='mdi mdi-24px mdi-arrow-collapse-up'></i> <div>Tải lên hình ảnh</div>",
          acceptedFiles: "image/jpeg,image/png,image/jpg",
          thumbnailWidth: 100,
          thumbnailHeight: 100,
          headers: {
            "Authorization": `Bearer ${JSON.parse(localStorage.getItem('user')).token}`,
            "Cache-Control": null, 
            "X-Requested-With": null
          },
        },
        editorOption: {
          placeholder: 'Nhập văn bản ở đây',
        },
        money: {
          decimal: ',',
          thousands: ',',
          precision: 3,
          masked: false
        },
        warehouses: [],
        warehouseSelected: [],
        invalidIds: []
      }
    },
    computed: {
      ...mapState([ 
        'config'
      ])
    },
    mounted() {
      this.dialog = this.showDialog;
      this.dropzoneOptions.url = `${this.config.beUrl}/api/v1/images`;
    },
    watch: {
      async showDialog() {
        const app = this;
        app.dialog = false;
        app.errors_exist=false;
        if (app.showDialog) {
          app.dialog = true;

          app.types = await app.getTypes();
          app.warehouses = await app.getWarehouses();

          if(!app.businessId){ // tài khoản admin
            app.businesses = await app.getBusinesses();
          } else { // tài khoản doanh nghiệp
            app.coopes = await app.getCoopesByBusiness();
          }
          
          app.anh_dai_dien_url = null;
          
          if(app.item.anh_dai_dien) {
            app.anh_dai_dien_url = `${app.config.beUrl}/uploads/${app.item.anh_dai_dien}`;
          }
          app.typeSelected = app.types.find(
            element => element.id == app.item.loai_id
          );
          app.businessSelected = app.businesses.find(
            element => element.id == app.item.co_so_id
          );
          
          if(app.item && app.item.prod_distributors){
            app.item.prod_distributors.forEach(function(value, index){
              app.coopeSelected.push(value);
            });
          }
          if(app.item && app.item.product_warehouses){
            app.warehouseSelected = [];
            app.item.product_warehouses.forEach(function(value, index){
              app.warehouseSelected.push(value);
            });
          }
          if(this.item.images){
            app.loadPictures();
          }
        }
      }
    },
    methods: {
      ...mapActions([
        'openSnackbar'
      ]),
      async getTypes () {
        let data = [];
        try{
          let response = await axios.get("api/v1/product-types");
          data = response.data;
        }catch(error) {
          console.log(error);
        };
        return data;
      },
      async getBusinesses () {
        let data = [];
        try{
          let response = await axios.get("api/v1/businesses");
          data = response.data.data;
        }catch(error) {
          console.log(error);
        };
        return data;
      },
      async getCoopesByBusiness() {
        let data = [];
        let id = 0;
        if(this.businessSelected){
          id = this.businessSelected.id;
        }
        if(this.businessId){
          id = this.businessId;
        }
        try{
          let response = await axios.get(`api/v1/distributors-by-business/${id}`);
          data = response.data;
        }catch(error) {
          console.log(error);
        };
        return data;
      },
      async getWarehouses () {
        let data = [];
        try{
          let response = await axios.get("api/v1/warehouses");
          data = response.data;
        }catch(error) {
          console.log(error);
        };
        return data;
      },
      close() {
        this.dialog = false;
        this.$emit('cancelled');
      },
      save(item) {
        const app = this;
        let method = "post";
        let url = `api/v1/products`;
        let data = item;
        let coopes = [];
        let warehouses = [];

        if(app.coopeSelected){
          app.coopeSelected.forEach(function(value, index){
            coopes.push(value.id);
          });
        }

        if(app.warehouseSelected){
          app.warehouseSelected.forEach(function(value, index){
            warehouses.push(value.id);
          });
        }

        data.coopes = coopes;
        data.kho_xuongs = warehouses;

        if(app.typeSelected){
          data.loai_id = app.typeSelected.id;
        }

        if(app.businessSelected){
          data.co_so_id = app.businessSelected.id;
        }

        if(app.businessId){
          data.co_so_id = app.businessId;
        }

        data.images = app.images;
        
        if (data.id) {
          method = "patch";
          url = `api/v1/products/${data.id}`;
        }

        app.loading=true;

        axios[method](url, data)
          .then((response) => {
            if (response.data && response.data.id) {
              app.$emit('confirmed', response.data);
            }
            app.loading=false;
          }).catch(function (error) {
            app.loading=false;
            app.errors_exist = true;
            if(error.response.status === 422) {
              app.errors = error.response.data || {};
            }
          });
      },
      onPickFile () {
        this.$refs.fileInput.click();
      },
      onFilePicked (event) {
        const app = this;
        app.loading=true;

        const file = event.target.files[0];
        app.anh_dai_dien_url = URL.createObjectURL(file);

        const config = {
          headers: { 'content-type': 'multipart/form-data' }
        };

        let formData = new FormData();
        formData.append('file', file);

        axios.post('api/v1/images', formData, config)
          .then(function (response) {
            app.item.anh_dai_dien=response.data.filePath;
            app.loading=false;
          })
          .catch(function (error) {
            app.loading=false;
            app.anh_dai_dien_url = null;
            app.openSnackbar({ type: 'error' });
          });
      },
      uploadSuccess(file, response) {
        this.images.push(response.fileId);
      },
      uploadError(file, message) {
        this.openSnackbar({ type: 'error' });
      },
      fileRemoved(file, error, xhr) {
        // const index = this.item.images.findIndex(item => item.path === file.name);
        // this.item.images.splice(index, 1);
        // this.images = [];
        // for(let img of this.item.images) {
        //   this.images.push(img.id);
        // }
        const app = this;
        if(app.dropzoneOptions.removeType == "server") {
          axios.post('api/v1/product-remove-slider', {
            productId: app.item.id,
            fileName: file.previewElement.querySelector("[data-dz-name]").innerHTML
          })
            .then(function (response) {
              file.previewElement.remove();
              app.invalidIds.push(response.data);
              app.openSnackbar({ type: 'success' });
            })
            .catch(function (error) {
              app.openSnackbar({ type: 'error' });
            });
        } else {
          file.previewElement.remove();
        }
      },
      loadPictures() {
        if(this.$refs.myVueDropzone){
          this.dropzoneOptions.removeType = "client";
          this.$refs.myVueDropzone.removeAllFiles(); 
          this.dropzoneOptions.removeType = "server";
          if(this.item.images) {
            this.item.images.forEach(image => {
              if(!this.invalidIds.includes(image.id)) {
                var file = { size: 123, name: image.path, type: "image/png" };
                var url = `${this.config.beUrl}/uploads/${image.path}`;
                this.$refs.myVueDropzone.manuallyAddFile(file, url);
              }
            });
          }
        }
      }
    }
  }
</script>